import React from 'react';

interface IWidgetContext {
    YccNewCaseManagementWidget?: any,
    YccCaWebFormWidget?: any,
    setYccCaWebFormWidget?: (widget: any) => any,
    setYccNewCaseManagementWidget?: (widget: any) => any
}

const Widgets = React.createContext<IWidgetContext>({
    YccNewCaseManagementWidget: null,
    setYccNewCaseManagementWidget: (widget: any) => console.debug("init setYccNewCaseManagementWidget: ", widget),
    YccCaWebFormWidget: null,
    setYccCaWebFormWidget: (widget: any) => console.debug("init setYccCaWebFormWidget: ", widget)
});

export default Widgets;